import { useState } from "react";
import MDEditor from "@uiw/react-md-editor";
import styled from "@emotion/styled";

const MarkDownEditor = ({ data }: any) => {
  const [value, setValue] = useState<any>(data);

  return (
    <Div className="container">
      <div data-color-mode="light">
        <MDEditor.Markdown source={value} className="markdown-display" />
      </div>
    </Div>
  );
};

export default MarkDownEditor;

const Div = styled.div`
  max-width: 1150px;
  margin: auto;
  /* padding: 90px 50px 90px 50px; */
  padding-top: 0px;
  .markdown-display {
    background-color: #ffffff;
    color: inherit;
    text-align: left;
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    font-family: "Roboto", sans-serif;
    letter-spacing: 0.025em;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeSpeed;
    font-weight: 400;
    color: #000;
  }
  table {
    width: 1152px;
  }
  table tr td:nth-child(2) {
    width: 800px;
  }
  table tr td:nth-child(1) {
    width: 30% !important;
    font-weight: 600;
    color: #1e1e1e;
    padding-right: 8px;
  }
  img {
    width: 70%;
    display: flex;
    justify-content: center;
    margin: auto;
  }
`;
